import { useEffect, useState } from "react";
interface TypeWriterProps {
  words: string[];
  delay?: number;
  pauseTime?: number;
}
export const TypeWriter: React.FC<TypeWriterProps> = ({
  words,
  delay = 100,
  pauseTime = 2000,
}) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  useEffect(() => {
    const word = words[currentWordIndex];
    const timeout = setTimeout(() => {
      if (!isDeleting) {
        if (currentText === word) {
          setTimeout(() => setIsDeleting(true), pauseTime);
          return;
        }
        setCurrentText(word.substring(0, currentText.length + 1));
      } else {
        if (currentText === "") {
          setIsDeleting(false);
          setCurrentWordIndex((prev) => (prev + 1) % words.length);
          return;
        }
        setCurrentText(word.substring(0, currentText.length - 1));
      }
    }, delay);
    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, currentWordIndex, words, delay, pauseTime]);
  return <span>{currentText}</span>;
};
